




















































































import Vue from 'vue';
import {
  Component, Inject, Watch,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { ReportResource } from '@/api/reports/ReportResource';
import { Report } from '@/api/reports/Report';
import CycleSelect from '@/components/cycles/CycleSelect.vue';
import { Cycle } from '@/api/cycles';

@Component({
  computed: mapState(['fiId']),
  components: { CycleSelect },
})
export default class DownloadReportsCard extends Vue {
  fiId!: string;

  selectedCycle: Cycle | null = null;

  reports: Report[] = [];

  selectedReportNames: string[] = [];

  selectedFileFormat: string = 'XLSX';

  availableFileFormats: string[] = ['XLSX', 'CSV', 'TXT'];

  @Inject('ReportResource')
  reportResource!: ReportResource;

  @Watch('selectedCycle')
  onCycleChange() {
    if (this.selectedCycle !== null) {
      this.getReportsForDate();
    }
  }

  @Watch('selectedFileFormat')
  onFileFormatChange() {
    if (this.selectedCycle !== null) {
      this.getReportsForDate();
    }
  }

  @Watch('fiId')
  onFiChange() {
    this.reports = [];
    this.selectedReportNames = [];
    this.selectedCycle = null;
    this.selectedFileFormat = 'XLSX';
  }

  async getReportsForDate() {
    this.reports = [];
    this.selectedReportNames = [];
    if (this.selectedCycle) {
      const searchDate = this.selectedCycle.endOfMonthDateInCycle
        ? this.selectedCycle.endOfMonthDateInCycle : this.selectedCycle.statementEndDate;
      this.reportResource.getReportInfosForReportDate(this.fiId, searchDate, this.selectedFileFormat).then((reports: Report[]) => {
        this.reports = reports;
      }).catch((error: any) => {
        this.showErrorMessage(error);
      });
    }
  }

  download() {
    this.selectedReportNames.forEach((fileName: string) => {
      this.downloadReport(fileName);
    });
  }

  async downloadReport(fileName: string) {
    if (this.selectedCycle) {
      const searchDate = this.selectedCycle.endOfMonthDateInCycle
        ? this.selectedCycle.endOfMonthDateInCycle : this.selectedCycle.statementEndDate;

      this.reportResource.downloadReportForDate(this.fiId, searchDate, fileName).then((reportContent: Blob) => {
        this.downloadReportContent(reportContent, fileName);
      }).catch((error) => {
        this.showErrorMessage(error);
      });
    }
  }

  downloadReportContent = (content: Blob, fileName: string) => {
    const anchor = document.createElement('a');
    anchor.href = URL.createObjectURL(content);
    anchor.download = fileName;
    anchor.click();
  }

  selectAll() {
    this.unselectAll();
    this.reports.forEach((report: Report) => {
      this.selectedReportNames.push(report.filename);
    });
  }

  unselectAll() {
    this.selectedReportNames = [];
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
